<template>
  <Layout footer>
    <div class="app-container text-base">
      <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
        <span class="mr-1">当前位置：</span>
        <NBreadcrumb>
          <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
          <NBreadcrumbItem>培训质量管控</NBreadcrumbItem>
        </NBreadcrumb>
      </div>
      <img class="carousel-img" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/banner9.png" />
      <div class="flex items-center my-4 zhu_yi">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/news.png" alt="" />
        <span class="mx-2 text-base font-bold">注意事项：</span>
        <span style="color: #f70707">
          管理平台属于业务主管部门后台管理功能，学员账号无访问权限。
        </span>
      </div>
      <div class="mt-14 pl-6" style="text-indent: 2em">
        <p>管理平台以确保培训质量为目的。管理部门可查看培训实时数据及时了解培训情况。</p>
        <p class="mt-4">
          可利用讲师备案、幵班审批、幵课情况、结业情况、实时督导、题库管理、培训档案、全程录像、大数据分析及数字审计等功能进行实时管理，全程掌握整个培训过程，确保培训质量和效率。
        </p>
      </div>
      <img class="w-full mx-auto mt-14" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line9.png" />
      <div class="mt-14 pl-6" style="text-indent: 2em">
        平台通过线上学习监管、及时答题、章节测试、学情跟踪、考试认证、讲师监管、每日反馈表、中期评估、结业评估、
        考核评审、线下节点监管、线下过程监管、监管照片及监管视频等数据智能判断学员是否合格，线上形成学员学习轨迹
        报告、线下学员学习轨迹以时间轴形式标注在照片及视频中提供审计查询依据。
      </div>
      <img class="w-10/12 mx-auto mt-14" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/content9.png" />
    </div>
  </Layout>
</template>

<script setup>
import Layout from '@/components/Layout';
import { useRouter } from 'vue-router';

const router = useRouter();
function gotoHome () {
  router.push('/');
}
</script>

<style lang="scss" scoped>
.carousel-img {
  display: block;
  width: 100%;
  height: 410px;
  object-fit: cover;
}

.zhu_yi {
  border: 1px dashed #f39a1d;
  height: 60px;
  font-size: 20px;
}
</style>
